import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
import axios from 'axios'
import msg from './msg'
import procs from './procs'
export default new Vuex.Store({

state:{
   localhost:'localhost',
   path: "vkback",
   loginSql: "root",
   paswordSql:"",
   serverSql: "localhost",

ui:{
  leftNav: true,
  startApp: false,

counters:{
  actions: 0,
  activity_proccess: 0,
  antigate: 0,
  info_pages: 0,
  list_of_groups: 0,
  list_of_pages: 0,
  pro: 0,
  processes: 98,
  profiles_tasks: 0,
  scripts: 0,
  sender: 0,
  tmp_data: 0,
  vk_profiles: 0,
  vk_profiles_gr: 0,
},
},


memory: {
    pages: 0,
    groups: 0,
    videos: 0,
    topics: 0,
    photos: 9,

},

filtersList:[
  {
    "10000":{
      name:"Фильтр вк",id:"10000",params:{}
    }
  }
],
 },


mutations:{
   leftNavOn(state,payload){
   state.ui.leftNav =  payload
   },
   changeCounters(state,payload){
   state.ui.counters =  payload
   },
   changeProfilesGroups(state,payload){
   state.ui.profilesGroups =  payload
   },
   changeFiltersList(state,payload){
   state.filtersList  =  payload
   },
},

actions:{
changeCounters(ctx){
axios.get('http://'+ this.state.localhost+'/'+this.state.path+'/ui/counters_get.php')
.then(response =>{
ctx.commit('changeCounters', response.data)
})
},
getProfilesGroups(ctx){
axios.get('http://'+ this.state.localhost+'/'+this.state.path+'/resources/accounts/gr_list_get.php')
.then(response =>{
ctx.commit('changeProfilesGroups', response.data)
})
},
getBotFilters(ctx){
axios.post('http://'+ this.state.localhost+'/'+this.state.path+'/filter/get_list_with_id.php',{data:{}})
.then(response =>{
ctx.commit('changeFiltersList', response.data)
})
},
},

 modules: {
 msg
 },


})
